import * as React from "react";
import "./footer.scss";
import {RootState} from "../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import HelpContactModal from "./help/modal/HelpContactModal";

interface IProps {
	/**
	 * System platform version.
	 */
	platformVersion: string
}

interface IState {
	/**
	 * Indicates if modal help is open.
	 */
	helpModalVisible: boolean;
}

class Footer extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);
		this.state = {helpModalVisible: false};
		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
	}

	render() {
		return (
			<footer className={"c-footer"}>
				<div className={"c-footer_copyright"}>{(new Date()).getFullYear()} © Driving Green Platform</div>
				<div className={"c-footer_version"}>Version {this.props.platformVersion}</div>
				<div className={"c-footer_help"}>
					<span className={"c-footer_help_link"} onClick={this.openModal}>
						<i className={"fa fa-question-circle"}/>&nbsp;Help
					</span>
				</div>
				{this.renderModal()}
			</footer>
		);
	}

	/**
	 * Render modal.
	 */
	renderModal() {
		if (this.state.helpModalVisible)
			return <HelpContactModal onClose={this.closeModal}/>
	}

	/**
	 * Open modal with help contact.
	 */
	openModal() {
		this.setState({helpModalVisible: true});
	}

	/**
	 * Close modal with help contact.
	 */
	closeModal() {
		this.setState({helpModalVisible: false});
	}
}

function mapStateToProps(state: RootState) {
	return {
		platformVersion: state.settings.settings.map(s => s.platformVersion).getOrElse("")
	}
}

export default connect(mapStateToProps)(Footer);